export const server = 'https://api.vkkr.apkpro.ru'